import { ChevronDown } from 'lucide-react'
import { motion } from 'motion/react'
import { FRAMER_MOTION_TOKEN_SELECT_EASING } from '@/src/utils/consts'
import { cn } from '@/src/utils/styles'
import { ChainImg } from '../../ui/chain-img'

export function FilterButtonImage({
  showChevron = false,
  size = 'default',
}: {
  size?: 'sm' | 'default'
  showChevron?: boolean
}) {
  const tokens = [ETH, SOL, OSMOSIS]

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.3,
        ease: FRAMER_MOTION_TOKEN_SELECT_EASING,
      }}
      className={cn('grid grid-cols-2 gap-0.5 size-12 min-w-12', {
        'size-8 min-w-8 gap-[1px]': size === 'sm',
      })}
      data-testid='filter-network'
    >
      {tokens.map(({ name, url, id }) => (
        <ChainImg
          key={id}
          chainImg={url}
          chainId={id}
          chainName={name}
          size={size}
          width={size === 'sm' ? 10 : 16}
          height={size === 'sm' ? 10 : 16}
          containerClassName={cn({
            'rounded-[4px]': size === 'sm',
          })}
        />
      ))}
      {showChevron ? (
        <div className='size-6 flex items-center justify-center rounded-[6px] bg-surface3'>
          <ChevronDown
            width={16}
            height={16}
            className='size-4 min-w-4 text-primary'
          />
        </div>
      ) : (
        <ChainImg
          chainImg={BSC.url}
          chainId={BSC.id}
          chainName={BSC.name}
          width={size === 'sm' ? 10 : 16}
          height={size === 'sm' ? 10 : 16}
          containerClassName={cn({
            'rounded-[4px] size-4 min-w-4': size === 'sm',
          })}
        />
      )}
    </motion.div>
  )
}

const ETH = {
  name: 'Ethereum',
  id: 'evm:1',
  url: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
}

const SOL = {
  name: 'Solana',
  id: 'solana:mainnet-beta',
  url: 'https://raw.githubusercontent.com/skip-mev/skip-go-registry/main/chains/solana/logo.svg',
}
const OSMOSIS = {
  name: 'Osmosis',
  id: 'cosmos:osmosis-1',
  url: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg',
}
const BSC = {
  name: 'BSC',
  id: 'evm:56',
  url: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png',
}
